import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';
import { View } from 'dripsy';
import { useCallback, useContext, useEffect, useState } from 'react';
import { AccountManagementStackRoutes, AccountManagementStackScreenProps } from '../../account.navigator';
import { ModalContainerView } from '../../../account-management/components/ModalContainerView';
import { TopUpMain } from './TopUpMain';
import { TopUpConfirm } from './TopUpConfirm';
import { TopUpPlaced } from './TopUpPlaced';
import { TopUpStackParamList, TopUpStackRoutes } from './type';

const TopUpStack = createNativeStackNavigator<TopUpStackParamList>();

export const TopUpNavigator: React.FC<AccountManagementStackScreenProps<AccountManagementStackRoutes.TopUp>> = ({ route }) => {
  const { func, refresh, record } = route.params;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const layout = useContext(LayoutContext);

  useEffect(() => {
    if (!layout.isMobile) return;
    setDimensions(layout.dimensions);
  }, [layout.dimensions]);

  const onLayout = useCallback((event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  }, []);

  const [data, setData] = useState(undefined);
  const onData = (data: any) => {
    setData(data);
  };

  const [returnData, setReturnData] = useState(undefined);
  const onReturnData = (data: any) => {
    setReturnData(data);
  };

  return (
    <ModalContainerView dimensions={dimensions}>
      <View sx={{ height: dimensions.height, width: dimensions.width }} onLayout={onLayout}>
        <TopUpStack.Navigator
          initialRouteName={TopUpStackRoutes.Main}
          screenOptions={{
            presentation: layout.isMobile ? 'modal' : 'transparentModal',
            headerShown: false
          }}>
          <TopUpStack.Screen
            name={TopUpStackRoutes.Main}
            component={TopUpMain}
            initialParams={{ onLayout, onData, onReturnData, func, refresh, record }}
            options={{ headerShown: false }}
          />
          <TopUpStack.Screen
            name={TopUpStackRoutes.Confirm}
            component={TopUpConfirm}
            initialParams={{ onLayout, data, onReturnData, func, refresh, record }}
            options={{
              presentation: 'transparentModal',
              headerShown: false,
              contentStyle: {
                backgroundColor: 'transparent'
              }
            }}
          />
          <TopUpStack.Screen
            name={TopUpStackRoutes.Placed}
            component={TopUpPlaced}
            initialParams={{ onLayout, data, returnData, record }}
            options={{ presentation: layout.isMobile ? 'modal' : 'transparentModal', headerShown: false }}
          />
        </TopUpStack.Navigator>
      </View>
    </ModalContainerView>
  );
};
